import { ToggleButton, ToggleButtonGroup } from '@mui/material';

// FEAT-002 관점 전환 selector — ADR-005 결정.
// 결정 5: 관점 전환 시 검색/필터 상태는 유지 (부모에서 처리, 본 컴포넌트는 view 만 변경).
export default function MatrixSelector({ value, onChange }) {
  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={(_, v) => v && onChange(v)}
      size="small"
      color="primary"
      sx={{ mb: 2, flexWrap: 'wrap' }}
    >
      <ToggleButton value="product-sw">제품 × 소프트웨어</ToggleButton>
      <ToggleButton value="feature-sw-version">기능 × 소프트웨어 × 버전</ToggleButton>
      <ToggleButton value="project-feature">프로젝트 × 기능</ToggleButton>
    </ToggleButtonGroup>
  );
}
